// extracted by mini-css-extract-plugin
module.exports = {"container":"_ac4f49d","background":"_3a40292","title":"_998610b","subTitle":"_daac370","callout":"_a483a9c","games":"_381e48b","game":"_8a4f4e3"};